import {Suspense} from 'react'
import {CopilotCodeReviewFindings} from '@github-ui/copilot-code-review-findings'
import {CollapsiblePanel} from './CollapsiblePanel'
import {ExpandableContent} from './ExpandableContent'
import {useFindingsQuery} from './data/route-queries'
import styles from './Findings.module.css'

/** Findings section — suspends while deferred data loads */
export function Findings() {
  return (
    <CollapsiblePanel heading="Findings">
      <Suspense fallback={null}>
        <FindingsContent />
      </Suspense>
    </CollapsiblePanel>
  )
}

function FindingsContent() {
  const {data} = useFindingsQuery()
  return (
    <ExpandableContent sectionLabel="Findings">
      <div className={styles.list}>
        <CopilotCodeReviewFindings {...data} />
      </div>
    </ExpandableContent>
  )
}
